import { QueryKey } from "@/utils";
import { useQuery } from "@tanstack/react-query";
import { GetAffiliatePayoutsRequest } from "@/api/affiliates/types";
import { AffiliateApi } from "@/api/affiliates";

export const useAffiliatePayouts = ({
  affiliateId,
  ...params
}: GetAffiliatePayoutsRequest) => {
  const { data, isError, isPending } = useQuery({
    queryKey: [QueryKey.AFFILIATE_PAYOUTS, affiliateId, params],
    queryFn: () => AffiliateApi.getAffiliatePayouts({ affiliateId, ...params }),
    enabled: !!affiliateId,
  });

  return {
    affiliatePayouts: data || [],
    affiliatePayoutsError: isError,
    isAffiliatePayoutsLoading: isPending,
  };
};
